<div class="modal-header">
    <div class="row col-12">
        <div class="modal-title col-10">
            <h3>Kopier kunde for {{ currentDepartment.name }} - [{{ currentDepartment.code }}]</h3>
        </div>
        <div class="col-2 align-self-center">
            <div class="text-end">
                <button type="button" class="btn" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
                    <span aria-hidden="true"><i class="fa-solid fa-x"></i></span>
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal-body col-8">
    <!-- Dropdown for Environments -->
    <div class="input-group mb-3">
        <label class="input-group-text" style="width: 100px;" for="environmentSelect">Miljø</label>
        <select class="form-select" id="environmentSelect" [(ngModel)]="selectedEnvironment"
            (change)="onEnvironmentChange($event)">
            @for (env of environments; track $index) {
            <option [value]="env"> {{ env }} </option>
            }
        </select>
    </div>

    <!-- Dropdown for Customers -->
    <div class="input-group mb-3">
        <label class="input-group-text" style="width: 100px;" for="customerSelect">Kunde</label>
        @if(loadingCustomers)
        {
        <span class="input-group-text flex-grow-1">Indlæser kunder...</span>
        }
        @else
        {
        <select class="form-select" id="customerSelect" [(ngModel)]="selectedCustomer">
            @for (option of customers; track $index) {
            <option [ngValue]="option"> {{option.customerId}} - {{ option.name }} </option>
            }
        </select>
        }
    </div>

    <p>Kopier regnskaber, samt deres opsætninger, fra det angivne miljø og den angivne kunde.</p>
</div>

<div class="modal-footer bg-transparent">
    <button class="btn btn-success float-end" [disabled]="isSaving" (click)="save()">
        @if(isSaving)
        {
        <div class="spinner-border spinner-border-sm me-2" role="status">
        </div>
        Importerer...
        } @else {
        Importer Opsætning
        }
    </button>
</div>